import React, { Component } from 'react';
import RoutingConstants from 'lib/RoutingConstants';
import {  post } from 'lib/api';
import StripeCheckout from 'react-stripe-checkout';
import Loader from 'lib/loader';

class CardDetail extends Component {
  constructor(props) {
    super(props);
    const lastDigits = 'You have not entered your credit card yet'
    this.state = {
      trial: this.props.reminder,
      lastDigits: this.props.lastDigits || lastDigits,
      inputs: {}, 
    };
  }

  
  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(props) {
    const lastDigits = 'You have not entered your credit card yet'
    this.setState({
      trial: props.reminder,
      lastDigits: props.lastDigits || lastDigits,

    })
  }
  
  
  updateDetail(value) {
    this.setState({ loadData: true });
    const url = RoutingConstants.updateCard;
    const { inputs } = this.state;
    inputs.stripe_token = value.id;
    post(url, inputs).then(() => {
      this.setState({ loadData: false });
      window.location.reload();
      // track edit payment detail
      const id = localStorage.getItem('email')
      window.analytics.track('Edit Payment Information Successful', {
        status: 'success',
        id
      });
    }).catch(() => {
      // track edit payment detail
      const id = localStorage.getItem('email')
      window.analytics.track('Edit Payment Information Unsuccessful', {
        status: 'failure',
        id
      });
    })
  }
  
  // eslint-disable-next-line
  cancelTrial() {
    const id = localStorage.getItem('email')
    window.analytics.track('Clicks Cancel Plan',{id});
  }

  render() {
    const { lastDigits, loadData, trial } = this.state;
    const key = RoutingConstants.key;

    return (
      <div className="free-trial-biling-dtail-box free-trial-biling-paymnt-info">
        {
          loadData &&
        <div className="loading">
          <Loader />
          <div className="modal-backdrop fade in" />
        </div>
        }
        <div className="row">
          <div className="col-md-9">
            <div className="free-trial-biling-inner-dtail">
              <p>Card Ending in: <i> {lastDigits} </i></p>
              { trial !== true &&
                <StripeCheckout
                  panelLabel='Update Card Details'
                  ComponentClass="div"
                  allowRememberMe={false}
                  image="https://stripe.com/img/documentation/checkout/marketplace.png"
                  token={(value) => this.updateDetail(value)}
                  stripeKey={key}
                >
                  <p className="sub-hdng">
                    To modify your card details, 
                    <span className="edit_crd_dtl" onClick={() => this.cancelTrial()}> click here. </span>
                  </p>
                </StripeCheckout>  
              }
            </div>
            <div className="free-trial-biling-inner-dtail">
              <p>
              To cancel your subscription, email us at support@prepday.com
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CardDetail;



// WEBPACK FOOTER //
// ./src/components/billingDetails/CardDetail.js